module.exports = __webpack_public_path__ + "img/cfcloud.d4949ee6.svg";